export default __webpack_public_path__ + "static/nera-f15f3d6b8ef441bb44d6eb42bb05114a.png";